<template>
    <!-- 弹窗 [[ -->
    <div class="g-popup" v-if="isShow">
        <div class="popup-con cozy-prompt-popup">
            <div class="popup-close"></div>
            <h5 class="popup-title">温馨提示</h5>
            <!-- 中间内容需要给出上下左右的margin或padding -->
            <div class="cozy-prompt-con">
                <p>{{ tips.msg }}</p>
            </div>
            <div class="g-bottom-btn">
                <a class="button popup-btn-confirm" href="javascript:;" @click="closeTips()">确定</a>
            </div>
        </div>
    </div>
    <!-- 弹窗 ]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/set/set.scss';
    .popup-title{text-align: left; margin-left: 2rem}
</style>
<script>
export default {
    name: 'tips.vue',

    data () {
        return {
            isShow: false,
            tips: {
                msg: ''
            }
        }
    },
    mounted(){

    },
    methods: {
        showTips(msg, isShow = true){
            this.tips.msg = msg;
            this.isShow = isShow;
        },
        closeTips(){
	            this.isShow = false;
        }
    }
}
</script>

<style scoped>

</style>
